import React from "react";
import XrayInsightsSlider from "./../../xray/XrayInsightsSlider";

export const XrayTooltipInsights = (props) => {
  const { data, insights } = props;

  const hasInsights =
    insights.find((d) => d.date === data.activeLabel) || false;
  // Remove first insight that's already in the tooltip
  const restInsights =
    hasInsights !== undefined && hasInsights.data
      ? hasInsights.data.slice(1)
      : false;

  return (
    <div>
      {restInsights && restInsights.length > 0 && (
        <div className="standard-tooltip__headers">
          <XrayInsightsSlider data={restInsights} />
        </div>
      )}
    </div>
  );
};
